import { CENTS_IN_DOLLAR, INITIAL_PRICE } from 'root-constants'
import { IRawSubscription, ISubscription } from 'models/subscriptions.model'

export const getSubscriptionListFromRawSubscriptionList = (
  rawSubscriptionList: IRawSubscription[],
): ISubscription[] =>
  rawSubscriptionList?.map((rawSubscription) => ({
    product: rawSubscription.product,
    priceId: rawSubscription.price_id,
    paypalPlanId: rawSubscription.paypal_plan_id,
    periodName: rawSubscription.interval,
    periodQuantity: rawSubscription.interval_count,
    currentPrice: rawSubscription.current_price / CENTS_IN_DOLLAR,
    fullPrice: rawSubscription.full_price / CENTS_IN_DOLLAR,
    oldPrice: rawSubscription.old_price / CENTS_IN_DOLLAR,
    oldPriceSecond: rawSubscription.old_price_second / CENTS_IN_DOLLAR,
    isDefault: rawSubscription.is_default,
    customPrice: rawSubscription.custom_price
      ? rawSubscription.custom_price / CENTS_IN_DOLLAR
      : INITIAL_PRICE,
    customPriceInterval: rawSubscription.custom_price_interval,
    trialPriceId: rawSubscription.trial_price_id,
    trialCurrentPrice: rawSubscription.trial_current_price
      ? rawSubscription.trial_current_price / CENTS_IN_DOLLAR
      : INITIAL_PRICE,
    trialPeriodDays: rawSubscription.trial_period_days,
    currency: rawSubscription.currency,
    discountAmount: rawSubscription.discount_amount / CENTS_IN_DOLLAR,
  }))
